import {
  CLEAR_ENTITY_HISTORY_DIALOG,
  FETCH_ENTITY_HISTORY_SUCCESS,
  SET_ENTITY_HISTORY_DIALOG,
} from '../actions/EntityHistoryActions';
import { formatEntityRows } from '../utils/entityHistoryUtils';

const initialState = {
  isOpen: false,
  rows: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ENTITY_HISTORY_DIALOG:
      return {
        ...state,
        isOpen: action.isOpen,
      };

    case CLEAR_ENTITY_HISTORY_DIALOG:
      return {
        ...state,
        rows: [],
      };

    case FETCH_ENTITY_HISTORY_SUCCESS:
      return {
        ...state,
        rows: formatEntityRows(action.rows),
      };

    default:
      return state;
  }
};
